import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { useFetchCreditNote } from 'receivable-invoices-js/react/api/queries/fetch-credit-note/fetch-credit-note';
import { fetchPdfSrc } from 'receivable-invoices-js/react/utils/pdf-utils/pdf-utils';

export function useRouteQuery() {
  const { id } = useParams<{ id: string }>();

  // Fetch credit note
  const creditNoteId = id || '';
  const {
    data: creditNote,
    isLoading: creditNoteLoading,
    isError: creditNoteError,
  } = useFetchCreditNote({ id: creditNoteId }, {}, { enabled: Boolean(creditNoteId) });

  // Fetch PDF source separately
  const { data: pdfSrc, isLoading: pdfLoading } = useQuery({
    queryKey: ['credit-note-pdf-src', creditNoteId, creditNote?.pdfUrl],
    queryFn: () => fetchPdfSrc(creditNote?.pdfUrl || ''),
    enabled: Boolean(creditNote?.pdfUrl),
  });

  return {
    creditNote: creditNote ? { ...creditNote, pdfSrc } : undefined,
    isLoading: creditNoteLoading || pdfLoading,
    isError: creditNoteError,
  };
}
